"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Images = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _helpers = require("react-platform-components/dist/helpers");
var _AvatarGroup = _interopRequireDefault(require("@material-ui/lab/AvatarGroup"));
var _config = require("../../../config");
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    avatar: {
      transition: "transform .2s ease-in-out",
      cursor: "pointer"
    },
    avatarGroup: {
      borderRadius: "8px"
    },
    popover: {
      overflow: "auto"
    }
  };
});
var Images = function Images(_ref) {
  var productName = _ref.productName,
    images = _ref.images;
  var classes = useStyles();
  var _useState = (0, _react.useState)(""),
    _useState2 = _slicedToArray(_useState, 2),
    url = _useState2[0],
    setUrl = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    imageAnchorEl = _useState4[0],
    setImageAnchorEl = _useState4[1];
  var handleImageHoverIn = function handleImageHoverIn(event, url) {
    setUrl(url);
    setImageAnchorEl(event.currentTarget);
  };
  var handleImageHoverOut = function handleImageHoverOut() {
    setUrl("");
    setImageAnchorEl(null);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_AvatarGroup.default, {
    classes: {
      avatar: classes.avatarGroup
    },
    max: 3
  }, images.map(function (image) {
    return /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: classes.avatar,
      imgProps: {
        onMouseEnter: function onMouseEnter(e) {
          return handleImageHoverIn(e, (0, _helpers.joinPaths)(_config.BASE_URL, image.url || ""));
        },
        onClick: function onClick(e) {
          return handleImageHoverIn(e, (0, _helpers.joinPaths)(_config.BASE_URL, image.url || ""));
        }
      },
      key: image.id,
      alt: productName + " image",
      src: (0, _helpers.joinPaths)(_config.BASE_URL, image.url || "")
    });
  })), /*#__PURE__*/_react.default.createElement(_core.Popover, {
    id: "image-popover",
    anchorEl: imageAnchorEl,
    open: Boolean(imageAnchorEl),
    onClose: handleImageHoverOut,
    className: classes.popover,
    anchorOrigin: {
      vertical: "center",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "center",
      horizontal: "right"
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    onMouseLeave: handleImageHoverOut,
    src: url,
    alt: "product",
    width: 300
  })));
};
exports.Images = Images;